import * as React from 'react';
import { connect } from 'react-redux';
import { AppState } from '../../store/reducers';
import { withStyles } from 'material-ui/styles';
import Grid from 'material-ui/Grid';
import Typography from 'material-ui/Typography';
import TextField from 'material-ui/TextField';
import appStyles from '../../utils/style';
import ListToolbar from '../../components/ListToolbar';
import Button from 'material-ui/Button';
import { genders as availableGenders, Gender } from '../../utils/gender';
import {
  countries as availableCountries,
  Country,
  countryById,
} from '../../utils/country';
import SelectMenu, { Selectable } from '../../components/SelectMenu';
import { saveIdol } from '../../store/Entities/Idols/idols.actions';
import {
  getIdolById,
  AppQuality,
} from '../../store/Entities/Idols/idols.reducer';
import { CircularProgress } from 'material-ui/Progress';
import { qualities } from '../../utils/quality';
import MediaDropzone from '../MediaDropzone';
import { getCdnUrl } from '../../utils/cdn';
import DeleteIcon from 'material-ui-icons/Delete';
import {
  reduce,
  indexOf,
  reject,
  append,
  update,
  merge,
  propEq,
  find,
} from 'ramda';
import {MediaItem} from '../../store/Entities/Media/media.reducer';
import * as R from 'ramda';

const styleSheet = {
    ...appStyles,
  profilePicPreview: {
    position: 'relative',
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    width: 200,
    height: 266,
  },
  deleteButton: {
    position: 'absolute',
    right: 5,
    bottom: 5,
    backgroundColor: '#f7412d',
    color: '#fff',
  }
};

export interface IdolProfileImage extends MediaItem {
  type: string;
}

export interface NewIdol {
  id?: number;
  name: string;
  gender: string;
  appIds?: number[];
  quality?: string;
  qualities?: {
    [key: number]: string;
  };
  images?: IdolProfileImage[];
}

interface StateProps {
  idolName: string;
  idolId?: number;
  idolGender: string;
  appIds?: number[];
  apps?: AppQuality[];
  quality?: string;
  loading: boolean;
  images?: IdolProfileImage[];
}

interface OwnProps {
  classes: any;
  idolName: string;
  idolId?: number;
  idolGender: string;
  appIds?: number[];
  apps?: AppQuality[];
  loading: boolean;
  quality?: string;
  images?: IdolProfileImage[];
}

type Props = typeof mapDispatch & OwnProps;

class IdolCreate extends React.PureComponent<Props, StateProps> {
  public constructor(props: Props) {
    super(props);
    const {
      idolName,
      idolGender,
      appIds,
      idolId,
      quality,
      apps,
      images,
    } = props;
    this.state = {
      idolId,
      idolName,
      idolGender,
      appIds,
      loading: false,
      quality,
      apps,
      images,
    };
  }

  public componentWillReceiveProps(props: Props) {
    const { idolId } = props;
    if (idolId) {
      const { idolName, idolGender, appIds, quality, apps, images } = props;
      this.setState({
        idolName,
        idolGender,
        appIds,
        idolId,
        quality,
        apps,
        images
      });
    }
  }

  private onStoryNameChange = (e: { target: HTMLInputElement }) => {
    this.setState({ idolName: e.target.value });
  };

  private onSubmitBtnClicked = (): void => {
    const { onSaveIdol } = this.props;
    const {
      idolId,
      idolGender,
      idolName,
      appIds,
      quality,
      apps,
      images
    } = this.state;

    onSaveIdol({
      idol: {
        name: idolName,
        gender: idolGender,
        id: idolId,
        appIds,
        quality,
        qualities: reduce(
          (actual, item: AppQuality) => {
            actual[item.id] = ['A', 'B', 'C', 'D'].includes(item.quality) ? item.quality : 'D';
            return actual;
          },
          {},
          apps || []
        ),
        images
      },
    });
  };

  private idolProfileChanged = (mediaItem?: MediaItem) => {
    this.setState({ images: this.replaceImage('profile', mediaItem) });
  };

  private replaceImage(type: string, mediaItem?: MediaItem) {
    const { images } = this.state;

    if (!images) {
      return [];
    }

    return [
      ...images.filter((image: IdolProfileImage) => {
        return image.type !== type;
      }),
      {
        ...mediaItem,
        type: type,
      } as IdolProfileImage,
    ];
  }

  private getImage(type: string) {
    const { images } = this.state;

    if (!images) {
      return { type: type } as IdolProfileImage;
    }

    return R.find((image: IdolProfileImage) => {
      return image.type === type;
    }, images);
  }

  private renderIdolImage() {
    const profileImage = this.getImage('profile');

    if (profileImage && profileImage.hash) {
      const {
        classes: { profilePicPreview, deleteButton },
      } = this.props;

      return (
          <div>
            <h3>Profile Image</h3>
            <div
                className={profilePicPreview}
                style={{ backgroundImage: `url(${getCdnUrl(profileImage.hash)})` }}
            >
              <Button
                  variant={'fab'}
                  className={deleteButton}
                  onClick={this.deleteIdolProfileImage}
              >
                <DeleteIcon />
              </Button>
            </div>
          </div>
      );
    }

    return (
        <div>
          <h3 style={{color: '#fff'}}>Idol Profile image</h3>
          <MediaDropzone
              zoneId="idol_profile"
              onUploaded={this.idolProfileChanged}
              width={200}
              height={250}
          />
        </div>
    );
  }

  private deleteIdolProfileImage = () => {
    this.idolProfileChanged(void 0);
  };

  private onGenderChange = (gender: Gender) => {
    const { name } = gender;
    this.setState({ idolGender: name });
  };

  private onCountryClicked = (country: Country) => {
    const appIds: number[] = this.state.appIds || [];
    const apps: AppQuality[] = this.state.apps || [];

    const { id } = country;
    const wasAdded: boolean = indexOf(id, appIds) > -1;
    const newAppIds: number[] = wasAdded
      ? reject(n => n === id, appIds)
      : append(id, appIds);
    const newApps = wasAdded
      ? reject((n: AppQuality) => n.id === id, apps)
      : append(
          {
            id,
            name: country.name,
            quality: 'unset',
          },
          apps
        );

    this.setState({
      appIds: newAppIds,
      apps: newApps as AppQuality[],
    });
  };

  private renderCountryButtons = (): JSX.Element => {
    const countries = availableCountries;
    const appIds: number[] = this.state.appIds || [];

    const btnStyle = (country: Country): object => {
      if (indexOf(country.id, appIds) === -1) {
        return { marginRight: 5 };
      }
      return {
        border: '1px solid rgb(225, 246, 148)',
        marginRight: 5,
      };
    };

    return (
      <Grid
        container={true}
        style={{ width: '100%', marginTop: 30, marginBottom: 30 }}
      >
        {countries.map((country: Country) => {
          return (
            <Button
              key={country.id}
              style={btnStyle(country)}
              onClick={() => this.onCountryClicked(country)}
            >
              {country.shortcode}
            </Button>
          );
        })}
      </Grid>
    );
  };

  private onQualityChanged = (item: Selectable, idx: number) => {
    const { apps } = this.state;
    if (!apps) {
      return;
    }
    const appAtIdx = apps[idx];

    if (appAtIdx) {
      this.setState({
        apps: update(idx, merge(appAtIdx, { quality: item.name }), apps),
      });
    }
  };

  private renderQualityRow = (appId: number, idx: number) => {
    const country: Country = countryById(appId);
    const { classes } = this.props;
    const { quality, apps } = this.state;

    const appQuality = find(propEq('id', appId))(apps || []) as AppQuality;

    return (
      <Grid item={true} xs={12} key={idx}>
        <Grid
          container={true}
          style={{ justifyContent: 'center', alignItems: 'center' }}
        >
          <Grid item={true} xs={6}>
            <Typography>{country.shortcode.toUpperCase()}</Typography>
          </Grid>
          <Grid item={true} xs={6}>
            <SelectMenu
              value={appQuality ? appQuality.quality : quality}
              placeholder="Select Type"
              className={classes.input}
              data={qualities}
              onChange={(item: Selectable) => this.onQualityChanged(item, idx)}
            />
          </Grid>
        </Grid>
      </Grid>
    );
  };

  private renderQualities = () => {
    const { appIds } = this.state;
    if (!appIds || appIds.length === 0) {
      return null;
    }

    return (
      <Grid container={true}>
        <Typography type="subheading" style={{ marginTop: 30 }}>
          Idol qualities
        </Typography>
        <Grid container={true}>{appIds.map(this.renderQualityRow)}</Grid>
      </Grid>
    );
  };

  public render() {
    const { classes, loading } = this.props;
    const { idolGender, idolName } = this.state;
    const genders = availableGenders;

    return (
      <div>
        <ListToolbar />
        <Grid
          container={true}
          style={{ width: 600, margin: '124px auto' }}
          spacing={40}
        >
          {loading && (
            <Grid
              container={true}
              style={{ width: '100%' }}
              alignItems="center"
              justify="center"
            >
              <CircularProgress
                style={{ color: '#e1f694', width: 60 }}
                size={60}
              />
            </Grid>
          )}
          {!loading && (
            <Grid item={true} xs={12}>
              <Typography type="title">Idol</Typography>

              {this.renderCountryButtons()}

              <Grid container={true} alignItems="center">
                <Grid item={true} xs={6}>
                  <TextField
                    type={'text'}
                    label="Name"
                    value={idolName}
                    className={classes.input}
                    onChange={this.onStoryNameChange}
                  />
                </Grid>
                <Grid item={true} xs={6}>
                  <Typography type="caption" className={classes.helpText}>
                    Name of the idol
                  </Typography>
                </Grid>
              </Grid>

              <Grid container={true} alignItems="center">
                <Grid item={true} xs={6}>
                  <SelectMenu
                    value={idolGender}
                    placeholder="Gender"
                    className={classes.input}
                    data={genders}
                    onChange={this.onGenderChange}
                  />
                </Grid>
                <Grid item={true} xs={6}>
                  <Typography type="caption">
                    Select a gender, where the story should be displayed.
                  </Typography>
                </Grid>
              </Grid>

              <Grid style={{ color: '#fff' }} item={true}>{this.renderIdolImage()}</Grid>

              {this.renderQualities()}

              <Grid container={true} style={{ marginTop: 50 }}>
                <Grid item={true} xs={12}>
                  <Grid
                    container={true}
                    direction="row"
                    alignItems="flex-end"
                    justify="flex-end"
                  >
                    <Grid item={true}>
                      <Button
                        onClick={this.onSubmitBtnClicked}
                        style={{ backgroundColor: '#e1f694', color: '#253238' }}
                      >
                        Accept
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state: AppState, ownProperties: any): StateProps => {
  const idolId = ownProperties.match.params.idolId;
  const idol = idolId ? getIdolById(state, idolId) : void 0;
  const images = idol ? idol.images && (idol.images as any).data : [];

  return {
    idolName: idol ? idol.name : '',
    idolGender: idol ? idol.gender : 'female',
    appIds: idol ? idol.appIds : [],
    apps: idol ? idol.apps : [],
    idolId,
    quality: idol ? idol.quality : 'A',
    loading: idolId && !idol,
    images,
  };
};

const mapDispatch = {
  onSaveIdol: saveIdol,
};

export default withStyles(styleSheet)(
  connect(
    mapStateToProps,
    mapDispatch
  )(IdolCreate)
);



// WEBPACK FOOTER //
// ./src/modules/IdolCreate/index.tsx